import React from 'react';
import AnimateHeight from 'react-animate-height';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Collapsable(_ref) {
  let {
    children,
    closed,
    onOpen = () => {},
    onClose = () => {},
    openDelay = 0,
    closeDelay = 250,
    duration = 250,
    ...rest
  } = _ref;
  const height = closed ? 0 : 'auto';
  return /*#__PURE__*/_jsx(AnimateHeight, {
    ...rest,
    height: height,
    duration: duration,
    onHeightAnimationEnd: handleTransitionEnd,
    delay: !closed ? openDelay : closeDelay,
    children: children
  });
  function handleTransitionEnd() {
    if (closed) {
      onClose();
    } else {
      onOpen();
    }
  }
}